module.exports = __webpack_public_path__ + "img/rule-bg.1dfa4a00.png";